import { ReactNode } from 'react';
import { Autocomplete, AutocompleteProps, mergeSlotProps, TextFieldProps } from '@mui/material';

import { StyledTextField } from '../index.js';

interface OwnProps {
    label: ReactNode;
    TextFieldProps?: TextFieldProps;
    options: (string | { label: string; value: string })[];
}

export type StyledAutocompleteProps<OptionType> = Omit<
    AutocompleteProps<OptionType, true, false, any>,
    'renderInput' | 'options'
> &
    OwnProps;

const StyledAutocomplete: FC<StyledAutocompleteProps<any>> = ({
    value,
    label,
    TextFieldProps: textFieldProps = {},
    inputValue,
    ...props
}) => {
    return (
        <Autocomplete
            value={value}
            inputValue={inputValue ?? ''}
            renderInput={(params) => (
                <StyledTextField
                    label={label}
                    {...params}
                    {...textFieldProps}
                    slotProps={mergeSlotProps(
                        {
                            inputLabel: {
                                shrink: inputValue?.length > 0 || value?.length > 0,
                            },
                        },
                        textFieldProps.slotProps ?? {}
                    )}
                />
            )}
            {...props}
        />
    );
};

export default StyledAutocomplete;
